<!-- Authored.by.KWShin.2024.03.05.-->
<template>
  <v-btn-toggle dense group>
    <v-menu v-model="showMenu" bottom left transition="slide-y-transition" :close-on-content-click="false">
      <template v-slot:activator="{ on }">
        <v-btn x-small>
          <v-icon small v-on="on">mdi-cog</v-icon>
        </v-btn>
      </template>
      <template>
        <div class="border-wrap">
          <v-card class="mx-auto" max-width="500">
            <v-list dense>
              <v-list-group no-action eager :style="{ width: '230px' }" id="gear-menu-text-field">
                <template v-slot:activator>
                  <v-list-item-title>{{ $t('dv.set.tnim.np') }}</v-list-item-title>
                </template>
                <v-text-field dense solo hide-details readonly :style="{ width: '230px', margin: '6px 0px 0px 0px' }" :value="tnimData.np | comma">
                  <template #prepend>
                    <v-tooltip content-class="tooltip" top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn id="minus-btn" class="icon" v-bind="attrs" v-on="on" x-small text @click="onIntervalMinus('np')">
                          <v-icon>mdi-minus-circle-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('common.minus.unit', { unit: options.tnim.unit }) }}</span>
                    </v-tooltip>
                  </template>
                  <template #append-outer>
                    <v-tooltip content-class="tooltip" top>
                      <template v-slot:activator="{ on, attrs }">
                        <div style="width: 120px">
                          <v-btn id="plus-btn" class="icon" v-bind="attrs" v-on="on" x-small text @click="onIntervalPlus('np')">
                            <v-icon>mdi-plus-circle-outline</v-icon>
                          </v-btn>
                          <span class="ml-2">({{ tnimData.npTime }})</span>
                        </div>
                      </template>
                      <span>{{ $t('common.plus.unit', { unit: options.tnim.unit }) }}</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-list-group>
              <v-divider class="mt-2 mb-2"></v-divider>
              <v-list-group no-action eager :style="{ width: '230px' }" id="gear-menu-text-field">
                <template v-slot:activator>
                  <v-list-item-title>{{ $t('dv.set.tnim.more.np') }}</v-list-item-title>
                </template>
                <v-text-field dense solo hide-details readonly :style="{ width: '230px', margin: '6px 0px 0px 0px' }" :value="tnimData.moreNp | comma">
                  <template #prepend>
                    <v-tooltip content-class="tooltip" top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn id="minus-btn" class="icon" v-bind="attrs" v-on="on" x-small text @click="onIntervalMinus('moreNp')">
                          <v-icon>mdi-minus-circle-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('common.minus.unit', { unit: options.tnim.unit }) }}</span>
                    </v-tooltip>
                  </template>
                  <template #append-outer>
                    <v-tooltip content-class="tooltip" top>
                      <template v-slot:activator="{ on, attrs }">
                        <div style="width: 120px">
                          <v-btn id="plus-btn" class="icon" v-bind="attrs" v-on="on" x-small text @click="onIntervalPlus('moreNp')">
                            <v-icon>mdi-plus-circle-outline</v-icon>
                          </v-btn>
                          <span class="ml-2">({{ tnimData.moreNpTime }})</span>
                        </div>
                      </template>
                      <span>{{ $t('common.plus.unit', { unit: options.tnim.unit }) }}</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-list-group>
              <v-divider v-if="options.cycleSet ? options.cycleSet.use : false" class="mt-2 mb-2"></v-divider>
              <v-list-group v-if="options.cycleSet ? options.cycleSet.use : false" no-action eager :style="{ width: '230px' }" id="gear-menu-text-field">
                <template v-slot:activator>
                  <v-list-item-title>{{ $t('dv.set.cycle') }}</v-list-item-title>
                </template>
                <v-text-field dense solo hide-details :style="{ width: '230px', margin: '6px 0px 0px 40px' }" v-model="cycleData.value">
                  <template #append-outer>
                    <div style="width: 120px">
                      <span class="ml-2">({{ cycleData.cycleTime }})</span>
                    </div>
                  </template>
                </v-text-field>
              </v-list-group>
            </v-list>
          </v-card>
        </div>
      </template>
    </v-menu>
  </v-btn-toggle>
</template>

<script>
import { mapState } from 'vuex';
import { api } from '@/api/common/instances';
import bus from '@/utils/bus';
import { s2Hms } from '@/utils/formatter.js';

export default {
  props: {
    /**
     *  options에는 다음과 같은 값이 넘어올 수 있다.
     *  {
     *    id: String, CONF_USER_MTL에 설정값을 저장할 때 사용할 MTL_ID의 prefix.
     *    tnim: {
     *      use: true/false, 설정 기능을 사용할 지 여부
     *      np: Number, 이전/이후 이동간격 초기값
     *      moreNp: Number, 더이전/더이후 이동간격 초기값
     *      unit: Number, 이전/이후/더이전/더이후 값을 증감시킬 때의 간격의 수
     *      minNp: Number, 이전/이후/더이전/더이후 간격의 최소값
     *      maxNp: Number, 이전/이후/더이전/더이후 간격의 최대값
     *    }
     *    cycle: Number(seconds), 한 간격의 시간 값
     *    cycleSet: {
     *      use: true/false, Cycle 설정 기능을 사용할 지 여부
     *      value: Number, 이동 간격 시간
     *      unit: Number(milliseconds), 이동 간격 시간 단위
     *    }
     *  }
     */
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showMenu: false,
      // TimeNavigator Interval for Moving.
      // Next/Previous, More Next/Previous.
      tnimData: {
        np: 10,
        moreNp: 30,
        previousNp: 10,
        previousMoreNp: 30,
        npTime: 0,
        moreNpTime: 0,
      },
      // BEGIN::Added.by.KWShin.2024.09.09
      cycleData: {
        value: 10,
        previousValue: 10,
        cycleTime: 0,
      },
      // FINISH::Added.by.KWShin.2024.09.09
    };
  },
  computed: {
    ...mapState('common/user', ['username']),
  },
  watch: {
    'cycleData.value': {
      handler() {
        this.cycleData.cycleTime = s2Hms(this.cycleData.value * this.options.cycleSet.unit);
      },
    },
    showMenu(value) {
      if (value) {
        /*
         * 보여지는 싯점에 이 컴포넌트에서 조작할 데이터를 초기화 한다.
         */
        if (this.options.tnim.use) {
          this.tnimData.np = this.options.tnim.np ? this.options.tnim.np : 10;
          this.tnimData.moreNp = this.options.tnim.moreNp ? this.options.tnim.moreNp : 30;
          this.tnimData.previousNp = this.tnimData.np;
          this.tnimData.previousMoreNp = this.tnimData.moreNp;
          this.tnimData.npTime = s2Hms(this.tnimData.np * this.options.cycle);
          this.tnimData.moreNpTime = s2Hms(this.tnimData.moreNp * this.options.cycle);
        }
        if (this.options.cycleSet?.use) {
          this.cycleData.value = this.options.cycleSet.value ? this.options.cycleSet.value : 10;
          this.cycleData.previousValue = this.cycleData.value;
          this.cycleData.cycleTime = s2Hms(this.cycleData.value * this.options.cycleSet.unit);
        }
      } else {
        /*
         * 감춰지는 싯점에 이 컴포넌트에서 조작한 데이터를 서버 DB에 반영하고,
         * 메인 컴포넌트가 변경된 조건에 따라 데이터를 다시 읽어 올수 있도록 bus에 이벤트를 보낸다.
         */
        if (this.options.tnim.use) {
          if (this.tnimData.np !== this.tnimData.previousNp) {
            api
              .put(`/prefer/users/${this.username}/motlet-properties`, {
                motletId: `${this.options.id}/np`,
                motletProperties: this.tnimData.np,
              })
              .then(() => {
                bus.$emit(`update:${this.options.id}-np`, this.tnimData.np);
              });
          }
        }
        if (this.options.tnim.use) {
          if (this.tnimData.moreNp !== this.tnimData.previousMoreNp) {
            api
              .put(`/prefer/users/${this.username}/motlet-properties`, {
                motletId: `${this.options.id}/moreNp`,
                motletProperties: this.tnimData.moreNp,
              })
              .then(() => {
                bus.$emit(`update:${this.options.id}-moreNp`, this.tnimData.moreNp);
              });
          }
        }
        if (this.options.cycleSet?.use) {
          if (this.cycleData.value !== this.cycleData.previousValue) {
            api
              .put(`/prefer/users/${this.username}/motlet-properties`, {
                motletId: `${this.options.id}/cycleValue`,
                motletProperties: this.cycleData.value,
              })
              .then(() => {
                bus.$emit(`update:${this.options.id}-cycleValue`, this.cycleData.value);
              });
          }
        }
      }
    },
  },
  methods: {
    onIntervalMinus(name) {
      if (this.tnimData[name] <= this.options.tnim.minNp) {
        this.$snackbar(this.$t('dv.info.tnim.lt.min', { min: this.options.tnim.minNp }));
        return;
      }
      this.tnimData[name] = parseInt(this.tnimData[name]) - this.options.tnim.unit;
      this.tnimData[name + 'Time'] = s2Hms(this.tnimData[name] * this.options.cycle);
    },
    onIntervalPlus(name) {
      if (this.tnimData[name] >= this.options.tnim.maxNp) {
        this.$snackbar(this.$t('dv.info.tnim.gt.max', { max: this.options.tnim.maxNp }));
        return;
      }
      this.tnimData[name] = parseInt(this.tnimData[name]) + this.options.tnim.unit;
      this.tnimData[name + 'Time'] = s2Hms(this.tnimData[name] * this.options.cycle);
    },
  },
};
</script>

<style>
/*
 * 'minus-btn'이라는 id를 가진 button 태그를 가진,
 * 'v-input__prepend-outer'라는 클래스를 가진 div 태그에 
 * CSS를 적용하라! 
 * 젠장... 이렇게 해서 Vuetify component의 slot이 가진
 * 디폴트 스타일을 변경했다.
 * 2024.01.17.KWShin.
*/
div.v-input__prepend-outer:has(button#minus-btn) {
  margin: 2px 0px 0px 10px;
}
div.v-input__append-outer:has(button#plus-btn) {
  margin: 2px 0px 0px 0px;
}
div#gear-menu-text-field div.v-input input {
  text-align: right;
}
</style>
